import React from 'react'
import Page403 from '../../components/common/Page403';

const PageForbidden = () => {
  return <Page403/>
}

export default PageForbidden;
